module.exports = __webpack_public_path__ + "img/logo-white.689b821e.png";